<template>
  <v-sheet>
    <v-card>
      <v-card-title><h2>Nowy element</h2></v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">

            <v-select v-model="elementSelected" :items="elementTypes"
                      item-text="description"
                      item-value="name"
                      label="Rodzaj akcji"
                      @change="model={}"
            ></v-select>
            <v-text-field v-model="name" label="Opis"></v-text-field>

            <div v-for="(field,key) in getActionFields(elementSelected)" :key="'action-field-' + key">

              <div v-if="field.type == 'multiFieldList'">
                <h3>{{ field.description }}</h3>
                <div>
                  <v-icon @click="addSubFieldsForMultiField(field)">add</v-icon>
                  <v-icon @click="removeSubFieldsForMultiField(field)">remove</v-icon>
                </div>

                <div v-for="(_,i) in field.length != undefined ? field.length : 0">
                  <h4>{{ i + 1 }}</h4>
                  <FieldElement v-for="(__,j) in field.options.subFields.length"
                                v-model="model[field.name][i][field.options.subFields[j].name]"
                                :element-types="elementTypes"
                                :field="field.options.subFields[j]" :schema="schema"
                                :schemas="schemas" :templates="templates">
                  </FieldElement>

                </div>
              </div>

              <FieldElement v-else v-model="model[field.name]"
                            :element-types="elementTypes"
                            :field="field" :schema="schema"
                            :schemas="schemas" :templates="templates">
              </FieldElement>

            </div>

            <v-btn @click="submit()">Ok</v-btn>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import eventActionType from "../../../enums/eventActionType"
import ColorPicker from '@radial-color-picker/vue-color-picker'
import FieldElement from './Field.vue'
import color from "@/mixins/color"
import Vue from "vue"

export default {
  mixins: [color],
  props: ['elementTypes', 'schema', 'templates'],
  components: {ColorPicker, FieldElement},
  data() {
    return {
      elementSelected: null,
      model: {},
      name: "",
      foreignSchema: {},
      schemas: [],
      EventActionType: eventActionType
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    },
    foreignFields() {
      if (!this.foreignSchema || this.foreignSchema == undefined) {
        return []
      }

      return this.getFields(false, this.foreignSchema.fields)
    },
    tableFields() {
      return this.getTableFields(this.schema.fields)
    },
    fields() {
      return this.getAllFields(this.schemaFields)
    }
  },
  created() {
    this.$http.get('/schemas').then(data => {
      this.schemas = data.data
    })
  },
  methods: {
    getFieldLength(field) {
      return field.length
    },
    schemaChanged(id) {
      this.$http.get(`/schema/${id}`).then(data => {
        this.foreignSchema = data.data
      })
    },
    getFields(type, fields) {
      let fieldsToFilter = fields != undefined ? fields : this.schema.fields
      return fieldsToFilter.filter(field => field.type != 'table' && type ? field.type == type : true)
    },
    getAllFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getTableFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getActionPropertyDescription(actionType, propertyName) {
      let action = this.elementTypes.find(el => el.name == actionType)
      let property = action ? action.properties.fields.find(el => el.name == propertyName) : null
      return property ? property.description : "Nieznana własciwość"
    },
    getActionFields(type) {
      let action = this.elementTypes.find(el => el.name == type)
      return action ? action.properties.fields : []
    },
    addSubFieldsForMultiField(field) {
      if (this.model[field.name] == undefined) {
        this.model[field.name] = []
        Vue.set(field, "length", 0)
      }

      let obj = {}
      field.options.subFields.forEach(sf => obj[sf.name] = "")
      this.model[field.name].push(obj)
      Vue.set(field, "length", field.length + 1)
    },
    removeSubFieldsForMultiField(field) {
      if (this.model[field.name] != undefined) {
        this.model[field.name].splice(-1)
        Vue.set(field, "length", field.length - 1)
      }
    },
    submit() {
      if (!this.elementSelected) {
        return
      }

      let postData = {
        'type': this.elementSelected,
        'name': this.name,
        'options': this.model
      }
      this.$http.post(`schema/${this.$route.params.schemaId}/element`, postData).then(data => {
        this.$emit('elementCreated', data.data)
        this.$store.commit('setSnack', {
          message: "Dodano akcje",
          color: 'success'
        })

        // this.$router.push({name: 'schema-related-map', params: {schemaId: this.$route.params.schemaId}})
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Nie można dodać akcji",
          color: 'error'
        })
      })
    },
  },
}
</script>
<style>
@import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
</style>
